export default __webpack_public_path__ + "static/media/benefit-gallery.57abff2a.png";